module.exports = __webpack_public_path__ + "img/kj5.c5be640b.png";